import React from 'react';
import { useLocation } from 'react-router-dom';
import Footer from './Footer';
import NavBar from './nav/NavBar';
import { Seo, withTemplate, canonicalize, defaultSite } from '@/lib/seo';
import { websiteJsonLd, orgJsonLd } from '@/lib/structuredData';
import { ClarityInjector, SalesIQInjector } from '@/lib/analytics/injectors';

interface LayoutProps {
  children: React.ReactNode;
}
export default function Layout({ children }: LayoutProps) {
  const location = useLocation();

  return (
    <>
      {/* Skip to main content link for keyboard users */}
      <a href="#main-content" className="skip-to-main">
        Skip to main content
      </a>

      {/* Sitewide SEO defaults */}
      <Seo
        title={withTemplate(defaultSite.defaultTitle)}
        description={defaultSite.defaultDesc}
        canonical={canonicalize(location?.pathname)}
        og={{
          title: defaultSite.defaultTitle,
          description: defaultSite.defaultDesc,
          url: canonicalize(location?.pathname),
          type: 'website',
        }}
        twitter={{
          card: defaultSite.twitterCard,
          title: defaultSite.defaultTitle,
          description: defaultSite.defaultDesc,
        }}
        jsonLd={[
          websiteJsonLd(defaultSite.baseUrl, defaultSite.name),
          orgJsonLd(defaultSite.baseUrl, defaultSite.name),
        ]}
      />

      <div className="min-h-screen bg-background relative">
        {/* Modern Responsive NavBar */}
        <NavBar />

        {/* Main Content */}
        <main id="main-content" role="main">
          {children}
        </main>

        {/* Footer */}
        <Footer />

        {/* Analytics Injectors (prod-only, env-gated) */}
        <SalesIQInjector />
        <ClarityInjector />
      </div>
    </>
  );
}
